import { useCallback, useState } from 'react';
import Persistor from 'Modules/persistor/persistor';
import {
    MAIL_FOLDER_INBOX,
    PERSIST_MAIL_FOLDER_KEY,
} from '../constants';

const getPersistedFolder = () => {
    const persisted = Persistor.get(`form.${PERSIST_MAIL_FOLDER_KEY}`);

    return persisted?.filterByFolder || MAIL_FOLDER_INBOX;
};

export const useMailFolder = () => {
    const [folder, setFolderState] = useState(getPersistedFolder);

    const setFolder = useCallback((nextFolder) => {
        setFolderState(nextFolder);

        Persistor.set(`form.${PERSIST_MAIL_FOLDER_KEY}`, {
            filterByFolder: nextFolder,
        });
    }, []);

    return [folder, setFolder];
};